import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchMessage = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/notifications/${id}`).then(response => {
    dispatch({
      type: types.FETCH_DRIVER,
      payload: {
        name: response.name,
        zones: response.zones,
      },
    });
    return response;
  });
